module.exports = __webpack_public_path__ + "assets/img/zzsl2.05a16124.png";